import "babel-polyfill";

const __svg__ = {
    path: '../icons/*.svg',
    name: 'icons/icons.svg'
}

import 'svgxuse';
require('./helpers/svgxhr')(__svg__);

import 'framework/App';

window.App.I18n.translations.fr = require( 'i18n/fr' ).default;
window.App.I18n.translations.en = require( 'i18n/en' ).default;
window.App.I18n.locale = window.lang;

// import 'modules/calendar';
import 'modules/country-dropdown';
import 'modules/expanding-grid';
import 'modules/form';
import 'modules/modal';
import 'modules/paysafe-checkout';
import 'modules/price-grid';

window.App.Navigation.init();



// WEBPACK FOOTER //
// ./resources/assets/js/app.js